export default "__VITE_ASSET__BzfK9YMV__"